
import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({
  name: 'InputAutoComplete',
})
export default class extends Vue {
  private input: any = ''
  @Prop({ default: [] }) data: Array<any>
  @Prop({ default: '' }) placeholder: string
  @Prop({ default: 'name' }) ObKey: string

  init() {
    this.$emit('init', this.input)
  }
}
